import React from 'react';
import Header from "../../header/Header";
import CartProduct from "./CartProduct";

const CartPage = () => {
    return (
        <div className="cart-page-wrapper">
            <Header/>
            <div className="cart-page-content xmt-25">
                <div className="container">
                    <CartProduct/>
                </div>
            </div>
        </div>
    );
};

export default CartPage;
